// extracted by css-extract-rspack-plugin
export default {"bubbleMenu":"wQvbA"};